<template>
  <p>
    <SkeletonBox width="100%" v-if="loading" />
    <template v-if="!loading">
      <span class="overviewbox-info-item-icon" v-if="icon">
        <i :class="[iconStyle, icon]"></i>
      </span>
      <slot />
    </template>
  </p>
</template>

<style scoped>
.overviewbox-info-item-icon {
  display: inline-block;
  margin: 0 auto;
  width: 1.3rem;
  color: #777a7c;
}
</style>


<script>
export default {
  name: "OverviewBoxInfoItem",
  props: {
    icon: {
      type: String,
      default: 'fa-info-circle'
    },
    iconStyle: {
      type: String,
      default: 'fas'
    }
  },
  computed: {
    loading() {     
      var loadingComponent = this.findLoadingParent(this.$parent)
      if(loadingComponent)
        return loadingComponent.$props.loading

      return false
    }
  },
  methods: {
    // Recursively find the parent 'ContentBox' or 'TabbedBox' components for the data item
    // Checks the parent's loading prop
    findLoadingParent(comp) {
      if(comp == null)
        return null
      if(comp.$options.name == 'OverviewBox')
        return comp

      return this.findLoadingParent(comp.$parent)
    }
  }
};
</script>